import { queryString, request } from '../../../shared/api/httpClient';
import type { Appointment } from '../../appointments';
export interface BookingRequest extends Appointment {
  request_status: number; created_at?: number; converted_appointment_id?: string | null;
  reject_reason?: string | null; assigned_station?: string; customer_email?: string;
}
export async function listBookingRequests(signal?: AbortSignal, status: number | 'all' = 0) {
  const items: BookingRequest[] = []; let page = 1;
  while (true) {
    const result = await request<{ list: BookingRequest[]; pagination: { total: number } }>('/booking-requests' + queryString({ request_status: status === 'all' ? undefined : status, limit: 100, page }), { signal });
    items.push(...result.list); if (!result.list.length || items.length >= result.pagination.total) break; page++;
  }
  return items;
}
